module.exports = require("async-to-gen/register");


//////////////////
// WEBPACK FOOTER
// external "async-to-gen/register"
// module id = 61
// module chunks = 0